"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRoleSearchModel = instanceOfRoleSearchModel;
exports.RoleSearchModelFromJSON = RoleSearchModelFromJSON;
exports.RoleSearchModelFromJSONTyped = RoleSearchModelFromJSONTyped;
exports.RoleSearchModelToJSON = RoleSearchModelToJSON;
exports.RoleSearchModelToJSONTyped = RoleSearchModelToJSONTyped;
/**
 * Check if a given object implements the RoleSearchModel interface.
 */
function instanceOfRoleSearchModel(value) {
    return true;
}
function RoleSearchModelFromJSON(json) {
    return RoleSearchModelFromJSONTyped(json, false);
}
function RoleSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'ugName': json['ugName'] == null ? undefined : json['ugName'],
    };
}
function RoleSearchModelToJSON(json) {
    return RoleSearchModelToJSONTyped(json, false);
}
function RoleSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'ugName': value['ugName'],
    };
}
